import Quickview from './Quickview'

export default {
  Quickview
}



// WEBPACK FOOTER //
// ./src/app/configuration/Hyundai/theme/components/quickview/index.js